<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
<div class="text-lg mb-5 font-semibold text-gray-800">Fee Payment</div>
<!-- Search Form (Matching Background) -->
<form class="flex bg-fieldset py-2 px-4 mb-3" [formGroup]="searchFormGrp" (ngSubmit)="searchHandler()">


  <div class="flex items-center space-x-6">
    <div class="flex flex-col mr-8">
      <mat-label class="required-label">Document ID</mat-label>
      <mat-form-field class="w-full" appearance="outline">
        <input matInput type="text" formControlName="caseNumber" placeholder="Enter Document ID" class="h-6 text-sm"
          [value]="feecaseData()?.docId || searchFormGrp.get('caseNumber')?.value || ''" />
        <mat-error *ngIf="searchFormGrp.get('caseNumber')?.hasError('required')" style="white-space: nowrap;">
          Please enter the Document ID to search
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Buttons in the same line -->
    <button type="reset" color="primary" class="mr-4" (click)="resetHandler()">Reset</button>
    <button type="submit" mat-flat-button color="primary">Search</button>
  </div>
</form>




<div *ngIf="isLoading()" class="flex justify-center">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<!-- Fee Assessment -->
<div class="p-2 border rounded-lg bg-fieldset mt-2" *ngIf="feecaseData() && !isLoading()">

  <!-- Fee Assessment Header with Divider -->
  <!-- Fee Assessment Header with Action Buttons -->
  <div class="flex justify-between items-center mb-2">
    <h3 class="text-lg font-semibold">Fee Payment</h3>

    <div class="flex space-x-2">
      <!-- Print Button -->
      <button *ngIf="!isEditing()" mat-button color="primary" (click)="onPrint()">
        <mat-icon class="mr-1">print</mat-icon>Print
      </button>
      <button mat-button color="warn" [disabled]="!feeForm.valid" *ngIf="isEditing()" (click)="_onsave()">
        <mat-icon class="mr-1">save</mat-icon>Save
      </button>
      <!-- Cancel Button -->
      <button *ngIf="isEditing()" mat-button color="primary" (click)="cancelEdit()">
        <mat-icon class="mr-1">cancel</mat-icon>Cancel
      </button>

      <!-- Edit Button -->
      <button mat-button color="primary" *ngIf="!isEditing() && !isDone()" (click)="toggleEdit()" [disabled]="isDone()">
        <mat-icon class="mr-1">edit</mat-icon>Edit
      </button>

      <!-- Save Button -->

    </div>
  </div>


  <!-- Divider Line -->
  <div class="border-b my-2"></div>

  <!-- First Row: Case Details (Reduced Horizontal Gap) -->
  <div class="grid grid-cols-3 gap-x-2 gap-y-4">
    <div>
      <mat-label style=" color: gray;">Case/ Appeal Number</mat-label>
      <p>{{ feecaseData()?.caseNumber }}</p>
    </div>
    <div>
      <mat-label style=" color: gray;">Document ID</mat-label>
      <p>{{ feecaseData()?.docId || '-' }}</p>
    </div>
    <div>
      <mat-label style=" color: gray;">Document Type</mat-label>
      <p>{{ feecaseData()?.docType || '-' }}</p>
    </div>
    <div>
      <mat-label style=" color: gray;">Fee Amount(Naira)</mat-label>
      <p>{{ feecaseData()?.feeAmount || '-' }}</p>
    </div>
    <div>
      <mat-label style=" color: gray;">No.Of.Pages</mat-label>
      <p>{{ feecaseData()?.pages || '-' }}</p>
    </div>
  </div>

  <!-- Form Section -->
  <form [formGroup]="feeForm" class="space-y-2 mt-8">
    <!-- Second Row: Fee Amount & Dropdowns -->
    <div class="grid grid-cols-3 gap-x-2 gap-y-2">

      <div>
        <mat-label class="required-label">Fee Type</mat-label>
        <mat-form-field class="w-full h-15">
          <!-- Incorrect Usage -->
          <mat-select formControlName="feeType">
            <mat-option *ngFor="let option of feeComponentTypes" [value]="option">
              {{ option.name }}
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>
      <div>
        <mat-label class="required-label">Fee Paid (Naira)</mat-label>
        <mat-form-field class="w-full h-15">
          <input type="number" formControlName="feeAmount" matInput />
          <mat-error *ngIf="feeForm.get('feeAmount')?.hasError('nonZero')">
            Amount cannot start with 0
          </mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-label class="required-label">Payment Type</mat-label>
        <mat-form-field class="w-full h-15">
          <mat-select formControlName="paymentType">
            <mat-option *ngFor="let option of paymentTypes" [value]="option">
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>

    <!-- Third Row: Larger Remarks Box -->
    <div class="grid grid-cols-3 gap-x-2">
      <div class="col-span-3">
        <mat-label>Remarks</mat-label>
        <mat-form-field class="w-full">
          <textarea rows="3" formControlName="remarks" matInput></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>


</div>